import { connect } from 'react-redux';
import FavoriteCinemas from './FavoriteCinemas.component';

const mapStateToProps = ({ cinemas: { cinemas } }) => ({
  cinemas: (cinemas || []).map(
    ({ name, cinemaUrlName, address1, address2, image, id, loyaltyCode, favorite }) => ({
      id,
      loyaltyCode,
      favorite,
      name,
      cinemaUrlName,
      address1,
      address2,
      image
    })
  )
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FavoriteCinemas);
